// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e_s4m","question":"styles_question__33ExY","description":"styles_description__1x9eb"};